export enum CrisEntityAction {
    CREATE = 'create',
    EDIT = 'edit',
}
